
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const parseInputNumber = (value: any) => {
  const parsedValue = parseFloat(value)
  if (isNaN(parsedValue)) {
    return undefined
  } else {
    return parsedValue;
  }
}